<template>
  <div class="m-modal" v-if="show" @click="confirm">
      <div class="content" @click.stop>
          <div class="title">
              {{ title }}
          </div>
          <div class="main">
              <slot name="main"></slot>
          </div>
          <div class="bottom" @click.stop="confirm">
              {{confirmText}}
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'VModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    confirmText: {
      type: String,
      default: '确定'
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm');
    }
  }
};
</script>

<style lang="scss" scope>
.m-modal {
 position: fixed;
 z-index: 996;
 top: 0; 
 width: 100%;
 height: 100%;
 background-color: rgba($color: #000000, $alpha: .4);
  .content{
      border-radius: 5px;
      width:90%;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      .main{
          padding: 15px 10px;
          font-size: 1.4rem;
          color: #666;
          line-height: 25px;
          overflow-y: auto;
          max-height: 28rem;
      };
      .title,.bottom{
          font-size: 1.6rem;
          text-align: center;
          padding: 10px 0;
      };
      .title{
          border-bottom: solid 1px #ebebeb;
      };
      .bottom{
          color: #ec2638;
          border-top: solid 1px #ebebeb;
          &:active{
              background-color: #ebebeb;
          }
      }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/base/modal.vue